import './style.scss'

interface ProfileIconProps {
	imgSrc?: string
}

function ProfileIcon({imgSrc}: ProfileIconProps) {

	return (
		<div className="profile-icon-wrap">
			{imgSrc &&
				<img
					className='profile-icon-img'
					src={imgSrc}
					alt='profile icon'
				/>
			}
		</div>
	)
}

export default ProfileIcon
